import { render, staticRenderFns } from "./EntityMetrics.vue?vue&type=template&id=05c515ae"
import script from "./EntityMetrics.vue?vue&type=script&lang=js"
export * from "./EntityMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports